import { EnvConfig } from "../../types";

export const communicationsConfigProd: EnvConfig = {
  MODULE_NAME: "communications",
  MODULE_ENV: "prod",
  LD_CLIENT_SIDE_ID: "63583be10d275b11a1f32f7c",
  MANIFEST_URL:
    "https://pipelines.app.coxautoinc.com/module-federation.manifest.json",
  BASE_URL: "https://inbox-bff-api.communications.app.coxautoinc.com/api/",
  MEDIA_BFF_URL: "https://media-bff-api.communications.app.coxautoinc.com",
  MEDIA_LIBRARY_URL: "https://media-library.vinccrm.cloud"
};
